import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img, a',
  standalone: true,
})
export class PreventDragDropDirective {
  @Input('rtPreventDragDrop') public enabled: boolean = true;

  constructor(private elRef: ElementRef) {}

  public ngOnInit(): void {
    if (this.enabled) {
      this.elRef.nativeElement.setAttribute('draggable', false);
    }
  }
}
